import { motion } from "framer-motion";
import { MapPin, Phone, Clock } from "lucide-react";

const details = [
  {
    icon: MapPin,
    label: "Find Us",
    value: "Karuna Complex, Court Road, N. Paravur, Kerala",
    href: "https://maps.google.com/?q=Karuna+Complex+Court+Road+North+Paravur",
    testid: "visit-address",
  },
  {
    icon: Phone,
    label: "Call or WhatsApp",
    value: "+91 73565 72909",
    href: "tel:+917356572909",
    testid: "visit-phone",
  },
  {
    icon: Clock,
    label: "Hours",
    value: "Open daily — call ahead to confirm timings",
    href: "tel:+917356572909",
    testid: "visit-hours",
  },
];

export const VisitUs = () => (
  <section
    id="visit"
    data-testid="visit-section"
    className="py-28 md:py-40 bg-[#2D1B36] text-[#FBF9F6] relative overflow-hidden"
  >
    <div
      className="absolute inset-0 opacity-[0.07] bg-cover bg-center"
      style={{
        backgroundImage:
          "url(https://images.unsplash.com/photo-1769420295409-ce777445e57b?auto=format&fit=crop&w=1600&q=60)",
      }}
    />
    <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="grid grid-cols-12 gap-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="col-span-12 md:col-span-5"
        >
          <p className="font-accent text-xs tracking-[0.35em] uppercase text-[#C5A059] mb-6">
            Visit the Shop
          </p>
          <h2 className="font-serif-d font-light text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
            Some threads you simply have to{" "}
            <span className="italic text-[#DFCA9B]">feel in your hands.</span>
          </h2>
          <p className="mt-8 text-base leading-relaxed text-[#FBF9F6]/70 max-w-md">
            Step into Innus Lace Centre and run your fingers along the lace
            library. Online orders are welcome too — place your order and pay
            securely online with UPI, card or netbanking.
          </p>
        </motion.div>

        <div className="col-span-12 md:col-span-6 md:col-start-7 flex flex-col justify-center divide-y divide-[#FBF9F6]/10">
          {details.map((d, i) => (
            <motion.a
              key={d.label}
              href={d.href}
              target={d.href.startsWith("http") ? "_blank" : undefined}
              rel="noopener noreferrer"
              data-testid={d.testid}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: 0.1 * i }}
              className="flex items-center gap-6 py-8 group"
            >
              <d.icon
                size={22}
                strokeWidth={1.25}
                className="text-[#C5A059] shrink-0"
              />
              <div>
                <p className="font-accent text-[10px] tracking-[0.3em] uppercase text-[#FBF9F6]/50 mb-1.5">
                  {d.label}
                </p>
                <p className="font-serif-d text-xl md:text-2xl text-[#FBF9F6] group-hover:text-[#DFCA9B] transition-colors duration-300">
                  {d.value}
                </p>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </div>
  </section>
);
